var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.thisNodeStatusColor,"size":"small"}},[_vm._v(" mdi-circle ")]),_c('span',{staticStyle:{"font-family":"Inter","font-size":"0.875rem","font-weight":"400","text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.thisNodeStatus))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }